module.exports = __webpack_public_path__ + "assets/5717b434ced914cf9f93f0a04fe291a1.mp3";